import fetch from '../fetch';

const queryCharts = (data) => {
    return fetch.post('zgcp/result/analysis/group/expert/convert/analysis', data)
    .then(res => {
        if(res.code === 200) {
            return {
                dataSource: res.payload.data,
            }
        }
        return {
            dataSource:[],
        }
    })
}

export default {
    queryCharts
}